















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
// @ts-ignore
import SwaggerUI from '@/components/Documentation/SwaggerUI.vue';

@Component({ name: 'SwaggerUxCustom', components: { SwaggerUI }, metaInfo: { title: 'UX API (Custom)' } })
export default class extends SaascadaVue {

    get url() {
        return process.env.VUE_APP_UX_BASE_URL + '/' + AuthModule.me.institution.code + '-openapi';
    }

}
